import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { FaTimes, FaCheck } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import indianStates from "../utils/states";
import { saveUser_Address } from "../Services/client";
import FullPageLoader from "./FullPageLoader";
import "../css/login.css";

const UserAddress = ({
  show,
  closeSignupForm,
  selAddressToEditId,
  callback,
}) => {
  const { t } = useTranslation();
  const [name, setName] = useState("");
  const [mobile_no, setMobileNo] = useState("");
  const [email, setEmail] = useState("");
  const [address1, setAddress1] = useState("");
  const [address2, setAddress2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [pin, setPin] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);

  useEffect(() => {
    if (selAddressToEditId > 0) {
      const userAddress = JSON.parse(
        localStorage.getItem("userAddress") || "[]",
      );
      const selected = userAddress.find((el) => el.id === selAddressToEditId);

      if (selected) {
        setName(selected.name || "");
        setMobileNo(selected.mobile_no || "");
        setEmail(selected.email || "");
        setAddress1(selected.address1 || "");
        setAddress2(selected.address2 || "");
        setCity(selected.city || "");
        setState(selected?.state || "");
        setPin(selected.pin || "");
      }
    } else {
      setName("");
      setMobileNo("");
      setEmail("");
      setAddress1("");
      setAddress2("");
      setCity("");
      setState("");
      setPin("");
    }
  }, [selAddressToEditId]);

  const handleSave = async () => {
    // setIsLoading(true);
    setError(null);

    if (validateAddress()) {
      setIsLoading(true);
      const formData = {
        name,
        mobile_no,
        email,
        address1,
        address2,
        city,
        state,
        pin,
        selAddressToEditId,
      };

      try {
        const userId = localStorage.getItem("userId");
        const response = await saveUser_Address(formData, userId);
        if (response.success === false) {
          setError("Failed to save user address");
        } else {
          localStorage.setItem(
            "userAddress",
            JSON.stringify(response.data.userAddress),
          );
          const deliveryAddress = response?.data?.userAddress?.filter(
            (el) => el.is_default === 1,
          );
          if (deliveryAddress?.length > 0) {
            localStorage.setItem(
              "deliveryAddress",
              JSON.stringify(deliveryAddress[0]),
            );
          }
          callback();
          setSuccessMsg(t("address_saved_message"));
        }
        setTimeout(() => {
          setIsLoading(false);
          closeSignupForm();
        }, 2000);
      } catch (err) {
        setError(err.message);
      }
    }
  };

  const validateAddress = () => {
    const newErrors = {};

    if (!name.trim()) {
      newErrors.name = t("name_required");
      setError(newErrors.name);
      return Object.keys(newErrors).length === 0;
    }
    if (!mobile_no.trim()) {
      newErrors.mobileNo = t("mobile_required");
      setError(newErrors.mobileNo);
      return Object.keys(newErrors).length === 0;
    }
    if (mobile_no && !/^\d{10}$/.test(mobile_no.replace(/\D/g, ""))) {
      newErrors.mobileNo = t("invalid_mobile");
      setError(newErrors.mobileNo);
      return Object.keys(newErrors).length === 0;
    }
    if (!address1.trim()) {
      newErrors.address1 = t("address1_required");
      setError(newErrors.address1);
      return Object.keys(newErrors).length === 0;
    }
    if (!address2.trim()) {
      newErrors.address2 = t("address2_required");
      setError(newErrors.address2);
      return Object.keys(newErrors).length === 0;
    }

    if (!email.trim()) {
      newErrors.email = t("email_required");
      setError(newErrors.email);
      return Object.keys(newErrors).length === 0;
    }
    if (
      email &&
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)
    ) {
      newErrors.email = t("invalid_email");
      setError(newErrors.email);
      return Object.keys(newErrors).length === 0;
    }

    if (!city.trim()) {
      newErrors.city = t("city_required");
      setError(newErrors.city);
      return Object.keys(newErrors).length === 0;
    }
    if (!state.trim()) {
      newErrors.state = t("state_required");
      setError(newErrors.state);
      return Object.keys(newErrors).length === 0;
    }
    if (!pin.trim()) {
      newErrors.pin = t("pin_required");
      setError(newErrors.pin);
      return Object.keys(newErrors).length === 0;
    }

    if (pin && !/^\d{6}?$/.test(pin)) {
      newErrors.pin = t("invalid_pin");
      setError(newErrors.pin);
      return Object.keys(newErrors).length === 0;
    }

    //setError(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  return (
    <Modal show={show} onHide={closeSignupForm} centered size="md">
      <Modal.Header closeButton className="modal-header-color">
        <Modal.Title className="cart-header">{t("add_address")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row className="form-narrow">
            <Col md={6}>
              <Form.Group className="mb-3 form-narrow-group">
                <Form.Label>{t("name")} <span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  value={name}
                  maxLength={100}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3 form-narrow-group">
                <Form.Label>{t("mobile_no")} <span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  value={mobile_no}
                  maxLength={10}
                  onChange={(e) => setMobileNo(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3 form-narrow-group">
                <Form.Label>{t("email")} <span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Control
                  type="email"
                  value={email}
                  maxLength={100}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3 form-narrow-group">
                <Form.Label>{t("address1")} <span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  value={address1}
                  maxLength={255}
                  onChange={(e) => setAddress1(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3 form-narrow-group">
                <Form.Label>{t("address2")} <span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  value={address2}
                  maxLength={255}
                  onChange={(e) => setAddress2(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3 form-narrow-group">
                <Form.Label>{t("city")} <span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  value={city}
                  maxLength={100}
                  onChange={(e) => setCity(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3 form-narrow-group">
                <Form.Label>{t("pin")} <span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Control
                  type="text"
                  value={pin}
                  maxLength={6}
                  onChange={(e) => setPin(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3 form-narrow-group">
                <Form.Label>{t("state")} <span style={{ color: "red" }}>*</span></Form.Label>
                <Form.Select
                  value={state}
                  maxLength={100}
                  onChange={(e) => setState(e.target.value)}
                  required
                >
                  <option value="">{t("select_state")}</option>
                  {indianStates
                    .sort((a, b) => a.localeCompare(b))
                    .map((state, idx) => (
                      <option key={idx} value={t(state)}>
                        {t(state)}
                      </option>
                    ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          {error && <p className="text-danger">{error}</p>}
          {successMsg && <p className="text-success">{successMsg}</p>}

          <div className="d-flex justify-content-end mt-3">
            <Button
              onClick={() => {
                handleSave();
              }}
              variant="success"
              disabled={isLoading}
              className="me-2"
            >
              <FaCheck className="me-1" size={12} />
              {isLoading ? t("saving") : t("save")}
            </Button>

            <Button
              onClick={closeSignupForm}
              className="form-close-button"
              disabled={isLoading}
            >
              <FaTimes className="me-2" size={12} />
              {t("close")}
            </Button>
          </div>
        </Form>
      </Modal.Body>
      {isLoading && <FullPageLoader />}
    </Modal>
  );
};

export default UserAddress;
